import { api } from './apiConfig';

/**
 * Get current setup progress for the authenticated user
 */
export const getSetupProgress = async () => {
  const response = await api.get('/setup/progress');
  return response.data;
};
